import { useContext } from 'react'
import {Link} from 'react-router-dom'
import {  useAuth } from './security/AuthContext'
import './HeaderComponent.css'






export default function HeaderComponent(){

//const authContext = useContext(AuthContext)
const authContext = useAuth()
const isAuthenticated = authContext.isAuthenticated


function logout(){
    authContext.logout()
}


//console.log(authContext.number)

    return(
        <header className="border-bottom border-light border-5 mb-5 p-2">
        <div className="container">
            <div className="row">
                <nav className="navbar navbar-expand-lg">
                    <a className="navbar-brand ms-2 fs-2 fw-bold text-black" href="https://validooo.github.io/FullStack-UserManagementApp-OpenApi-Springboot-Java-Vue/">User App</a>
                    <div className="collapse navbar-collapse parent">
                        <ul className="navbar-nav">
                            { isAuthenticated &&
                            <li className="nav-item fs-5"><Link className="nav-link" to="/welcome/Validooo">Home</Link></li>
}
{ isAuthenticated &&
                            <li className="nav-item fs-5"><Link className="nav-link" to="/todos">Todos</Link></li>
}      
{ isAuthenticated &&
<h2 className="child">Validooo</h2>
}
                        </ul>
                    </div>
                    <ul className="navbar-nav">
                        { !isAuthenticated &&
                        <li className="nav-item fs-5"><Link className="nav-link" to="/login">Login</Link></li>
}
{isAuthenticated &&
                        <li className="nav-item fs-5"><Link className="nav-link" to="/logout" onClick={logout}>Logout</Link></li>
}
                    </ul>
                </nav>
            </div>
        </div>
    </header>
    )
}